<template>
    
    <div id="lessonSliderComponent">

        <audio id="alarmAudio">
            <source src="" type="audio/mp3">
        </audio>

        <audio id="lessonIncomingCallAudio">
            <source src="" type="audio/mp3">
        </audio>

        <!--
        <button @click="testEndSession()">end</button>
        <button @click="showMemberFeedbackModal()">showMemberFeedbackModal</button>
        <button @click="testConsecutive()">end</button>
        <button @click="showMemberFeedbackModal()">hide</button>
        -->

        

        <!-- Tutor to Member Feedback-->
        <MemberFeebackComponent 
            ref="memberFeedback" 
            :user_info="this.$props.user_info" 
            :reservation="this.$props.reservation" 
            :api_token="this.api_token" 
            :csrf_token="this.csrf_token"/>

        <!-- Member Satisfaction Survey Component-->
        <SatisfactionSurveyComponent 
            ref="satisfactionSurvey" 
            :folder_id="this.$props.folder_id" 
            :is-broadcaster="this.$props.is_broadcaster" 
            :api_token="this.api_token" 
            :csrf_token="this.csrf_token"/>   
    
        <TutorSessionInvitePopUpComponent 
            ref="TutorSessionInvite" 
            :reservation="this.$props.reservation" 
            :lesson_history="this.lesson_history" 
            :is_broadcaster="this.$props.is_broadcaster" 
            :lesson_time_bypass="shouldAutoConnectLesson"
            :student_online="studentOnline"
            :api_token="this.api_token" 
            :csrf_token="this.csrf_token"/>

        <MemberConsecutiveLessons 
            ref="MemberConsecutiveLessons"
            :consecitive_lesson="consecutiveSchedules"
            :api_token="this.api_token" 
            :csrf_token="this.csrf_token"/>   

        <!-- LESSON BOARD / CANVAS toggle disabled; nav bar unchanged -->
        <NavigationMenu 
            ref="NavigationMenu"
            :reservation="this.$props.reservation" 
            :is_lesson_completed="isLessonCompleted"        
            :is_broadcaster="this.$props.is_broadcaster"
            :api_token="this.api_token" 
            :csrf_token="this.csrf_token"/>
        
        <MemberLessonTimerComponent 
            ref="MemberLessonTimer" 
            :api_token="this.api_token" 
            :csrf_token="this.csrf_token"/>

        <LessonSlider 
            ref="LessonSlider" 
            :channelid="this.$props.channelid"
            :user_info="this.$props.user_info"
            :member_info="this.$props.member_info"
            :recipient_info="this.$props.recipient_info"
            :is_lesson_started="this.isLessonStarted"
            :canvas_server="this.$props.canvas_server"
            :canvas_width="this.$props.canvas_width"
            :canvas_height="this.$props.canvas_height"
            :folder_id="this.$props.folder_id" 
            :reservation="this.$props.reservation" 
            :is_broadcaster="this.$props.is_broadcaster"
            :canvas_enabled="false"
            :api_token="this.api_token" 
            :csrf_token="this.csrf_token"/>

        <MemberFloatingChat
            ref="memberFloatingChat" 
            v-if="this.$props.is_broadcaster == false"
            :userid="''+this.user_info.id+''" 
            :username="this.user_info.username"
            :user_image="this.user_image"        
            :nickname="this.user_info.firstname"        
            :customer_support_image="'images/cs-profile.png'"
            :chatserver_url="this.chatserver_url"
            :api_token="this.api_token" 
            :csrf_token="this.csrf_token"
            :show_sidebar="false"
            :show_floating_icon="false"
        />
        
    </div>

</template>


<script>
    import {fabric} from "fabric";
    import NavigationMenu from './NavigationMenu.vue';
    import LessonSlider from './LessonSliderComponent.vue';
    import MemberLessonTimerComponent from './MemberLessonTimerComponent.vue';
    import SlideSelectorComponent from './SlideSelectorComponent.vue';
    import TutorSessionInvitePopUpComponent from './TutorSessionInvitePopUpComponent.vue';
    import MemberFloatingChat from '../chat/MemberFloatingChatComponent.vue';
    import MemberConsecutiveLessons from './MemberConsecutiveLessonsComponent.vue';
    import SlideUploaderComponent from './SlideUploaderComponent.vue'
    import MemberFeebackComponent from './MemberFeebackComponent.vue'
    import SatisfactionSurveyComponent from './SatisfactionSurveyComponent.vue'
    // TutorDisconnectedComponent removed — rely on webcam overlay messages instead.

    export default {

        name: "lessonSliderComponent",
        components: { 
            NavigationMenu,
            TutorSessionInvitePopUpComponent, 
            SlideSelectorComponent, 
            SlideUploaderComponent, SatisfactionSurveyComponent, MemberFeebackComponent,
            MemberFloatingChat, MemberLessonTimerComponent, MemberConsecutiveLessons, LessonSlider
        },
        props: {

            chatserver_url: String, //This will fire chat server on webRTC page
            canvas_server: String,
            channelid: Number,
            folder_id: Number,
            folder_url_array: Array,

            reservation: Object,       
            consecutive_schedules: Object,       
           

            user_info: Object,
            user_image: String,   
            member_info: Object,                    
            recipient_info: Object,

            is_broadcaster: Boolean,
            csrf_token: String,		
            api_token: String,

            is_lesson_started: Boolean,            
            is_lesson_completed: Boolean,

            lesson_history: Object, 

            canvas_width: String,
            canvas_height: String,

            auto_connect_lesson: {
                type: Boolean,
                default: false,
            },
        },
        data() {        
            
            return {

                disconnectTimeout: null,

                reconnected: false,

                message: null,
                currentFolderURLArray: [], //Folder Array Name
                consecutiveSchedules: [],

                //Main Countdown (Timer)
                isMainTimerStarted: false,
                formattedTime: "00:00:00",
                hours: 0,
                minutes: 0,
                seconds: 0,
                countdownInterval: null, 

                //Call waiting (Absent time)
                absentStartTime: null,
                callWaitingLimit: null, //default time

                //Lesson Status
                isLessonStarted: false,   
                isLessonExpired: false,
                isLessonCompleted: false, 
                isUserAbsent: false, 
                isLessonStartTimeInvalid: false,  

                //Session (all of components)
                isSessionExpired: true, 

                //Grace Period
                gracePeriodInMinutes: null,

                //slides data
                currentSlide: null,
                slidesData: null,

                pendingIncomingCall: null,
                incomingCallAudioInterval: null,
                isPlayingIncomingCall: false,
                lessonParticipantsConnected: false,
                lessonCallAnswered: false,
                tutorBypassConnectTimer: null,
                peerSessionUiReady: false,
                // Presence: "is the peer online AND registered in this lesson room?"
                studentOnline: false, // deprecated (kept for prop compatibility)
                studentPresentInRoom: false,
                tutorPresentInRoom: false,
                canvasEnabled: false,
                canvasStatePollTimer: null,
                lessonTimerSyncTimer: null,
                lastStudentPresentInRoom: false,
                lastTutorPresentInRoom: false,
            }
        },
        computed: {
            isTutorBroadcaster() {
                return this.$props.is_broadcaster === true
                    || this.$props.is_broadcaster === 'true'
                    || this.$props.is_broadcaster === 1;
            },
            shouldAutoConnectLesson() {
                return this.$props.auto_connect_lesson === true
                    || this.$props.auto_connect_lesson === 'true'
                    || this.$props.auto_connect_lesson === 1;
            },
        },
        created() {
            
            this.lessonStatus           = this.$props.reservation.schedule_status;  //TEXT STATUS
            this.isLessonStarted        = this.$props.is_lesson_started;            //BOOLEAN   - LESSON STARTED
            this.isLessonCompleted      = this.$props.is_lesson_completed           //BOOLEAN   - COMPLETED STATUS
            this.consecutiveSchedules   = this.$props.consecutive_schedules;
            this.currentFolderURLArray  = this.$props.folder_url_array;              //ARRAY     - folderURLArray        

        },
        mounted() {

            console.log(this.$props.canvas_server)

            this.socket = window.io(this.$props.canvas_server, {
                transports: ['websocket', 'polling'],
                reconnection: true,
                reconnectionAttempts: 10,
                reconnectionDelay: 1000,
            });

            window.lessonSliderComponent = this;
            /* LESSON BOARD / CANVAS — disabled
            window.setLessonCanvasEnabled = (enabled) => {
                this.setCanvasEnabled(!!enabled, !!enabled);
            };
            this.$nextTick(() => this.applyLessonLayout());
            */

            this.user = {
                channelid: this.lessonChannelId(),
                userid: String(this.user_info.id || this.member_info.user_id),
                nickname: this.user_info.firstname,
                username: this.user_info.username,
                firstname: this.user_info.firstname,
                lastname: this.user_info.lastname,
                status: "ONLINE",
                type: (this.user_info.user_type || 'MEMBER').toUpperCase(),
                image: this.$props.user_image
            };

            // this.bindLessonCanvasSocketEvents(); // LESSON BOARD / CANVAS — disabled

            this.socket.on('connect', () => {
                this.registerLessonSocketUser();
                this.announceLessonPresence();
                /* LESSON BOARD / CANVAS — disabled
                if (!this.isTutorBroadcaster) {
                    setTimeout(() => this.requestCanvasState(), 500);
                    this.startCanvasStatePolling();
                }
                */
                if (typeof window !== 'undefined') {
                    window.dispatchEvent(new CustomEvent('lesson-socket-ready', {
                        detail: { socket: this.socket },
                    }));
                }
                if (this.isTutorBroadcaster && !this.lessonCallAnswered && !this.lessonParticipantsConnected) {
                    const callDelay = this.shouldAutoConnectLesson ? 500 : 2000;
                    setTimeout(() => {
                        if (!this.lessonCallAnswered && !this.lessonParticipantsConnected) {
                            this.callMember();
                        }
                    }, callDelay);
                }
                if (this.isLessonSessionActive()) {
                    this.scheduleLessonTimerSync();
                    if (this.isTutorBroadcaster) {
                        this.broadcastMemberTimerStateIfRunning();
                    }
                }
            });

            if (typeof window !== 'undefined') {
                window.dispatchEvent(new CustomEvent('lesson-socket-ready', {
                    detail: { socket: this.socket },
                }));
            }

            this.socket.on('MEMBER_RECONNECT', () => {
                console.log('member reconnecting...');

                if (this.isLessonSessionActive()) {
                    return;
                }

                setTimeout(() => {
                    if (!this.isLessonSessionActive()) {
                        this.socket.emit('CALL_USER', this.buildCallUserPayload());
                    }
                }, 1000);
            });
        
        
            this.socket.on('peer-disconnected', ({role, intentional}) => {

                // 'peer-disconnected' always refers to the other party in this room
                // (server rooms are strictly 1:1 tutor/student) — no userId match needed.
                if (!this.isTutorBroadcaster && role === 'tutor') {
                    let tutor = this.$props.recipient_info;
                    if (this.isLessonCompleted == false) {
                        console.log("my tutor was disconnected : " + tutor.userid, intentional)
                        this.reconnected = false;
                        this.tutorPresentInRoom = false;
                        if (typeof window !== 'undefined' && typeof window.setLessonRemoteOverlay === 'function') {
                            window.setLessonRemoteOverlay('Tutor got disconnected — waiting to reconnect…', { source: 'app', lock: true });
                        }
                    }
                }
            });
            

            //send the current folder URL so it feedback url lesson will update
            if (this.$refs['memberFeedback'] && Array.isArray(this.currentFolderURLArray) && this.currentFolderURLArray.length) {
                this.$refs['memberFeedback'].updateLessonDetails(this.currentFolderURLArray);
            }


            /* CONSECUTIVE LESSON (transfered to get Lesson Materials)
                this.$refs['memberFeedback'].updateConsecutiveSchedules(this.consecutiveSchedules);                  
            */

            this.consecutiveSchedules = this.$props.consecutive_schedules;            
            this.checkLessonSessionStatus();         

            // 'update_user_list' has no shared-server equivalent (no broad presence
            // broadcast); peer presence is now driven by the real 'user-joined' event below.

            this.socket.on('user-joined', () => {
                const peer = Object.assign({}, this.$props.recipient_info, {
                    type: this.isTutorBroadcaster ? 'MEMBER' : 'TUTOR',
                });
                this.handlePeerJoinedSession(peer);
            });

            this.socket.on('auth-error', (payload) => {
                console.error('[lesson] room join rejected:', payload && payload.message);
            });

            this.customSelectorBounds(fabric);

            setTimeout(() => {
                this.announceLessonPresence();
                // Do not auto-join the lesson session here.
                // The tutor should keep dialing until the member accepts/joins.
            }, 2500);

            this.socket.on('START_SESSION', (response) => {

                console.log("start session")

                if (response.recipient.userid == this.user_info.id) {                    
                    console.log("tutor started a session");   
                    if (this.isMainTimerStarted == false) {                        
                        this.startCountdown(); 
                    }                
                }
            }); 

            this.socket.on('END_SESSION', (response) => {
                if (response.channelid == this.channelid) 
                {
                    

                    console.log("END SESSION RECIEVED BY MEMBER", response)
                    this.$refs['NavigationMenu'].stopTimer(); 
                    this.$refs['NavigationMenu'].disableNavigationMenu();

                    this.isLessonCompleted = true;
                    this.markLessonChannelActive(false);
                    // this.$refs['satisfactionSurvey'].showSatisfactionSurveyModal(this.reservation);
                    $("#destroy-session-media").trigger("click");

                       this.promptSessionComplete();
                }
            });  


            this.socket.on('CALL_USER', (userData) => {
                console.log("socket on CALL_USER", userData);

                const callerType = ((userData.caller && userData.caller.type) || '').toUpperCase();
                if (this.isTutorBroadcaster || callerType !== 'TUTOR') {
                    return;
                }

                const myId = String(this.user && this.user.userid);
                const targetId = String(
                    (userData.reservationData && userData.reservationData.member_user_id)
                    || (userData.recipient && (userData.recipient.userid || userData.recipient.userId))
                    || ''
                );
                if (targetId && myId && targetId !== myId) {
                    console.warn('CALL_USER ignored on lesson room — logged in as', myId, 'call is for', targetId);
                    return;
                }

                if (this.isLessonSessionActive()) {
                    console.log('CALL_USER while lesson already active — tutor reconnected, skipping ring');
                    this.handleTutorReconnectDuringLesson(userData);
                    return;
                }

                console.log('RECIEVED A CALL FROM TUTOR ', userData);
                this.destroyReconnect();
                this.pendingIncomingCall = userData;
                this.emitCallPingback(userData.caller);

                this.$refs['TutorSessionInvite'].showIncomingCallModal(userData.caller);
                this.playIncomingCallAudio();
            });

            this.socket.on('JOIN_SESSION', (joinUser) => {
                if (!this.isTutorBroadcaster || this.lessonCallAnswered || this.lessonParticipantsConnected) {
                    return;
                }
                const expectedMemberId = this.$props.recipient_info && String(this.$props.recipient_info.userid);
                const joinedId = joinUser && String(joinUser.userid);
                if (expectedMemberId && joinedId === expectedMemberId) {
                    console.log('member joined lesson channel — tutor calling', joinedId);
                    this.callMember();
                }
            });

            this.socket.on('MEMBER_ACCEPTED_CALL', (userData) => {
                if (!this.isTutorBroadcaster) {
                    return;
                }
                console.log('MEMBER_ACCEPTED_CALL', userData);
                this.onLessonCallAnswered(userData);
            });

            this.socket.on('LESSON_CALL_ANSWERED', (userData) => {
                if (!this.isTutorBroadcaster) {
                    return;
                }
                console.log('LESSON_CALL_ANSWERED', userData);
                this.onLessonCallAnswered(userData);
            });

            this.$root.$on('studentAcceptIncomingCall', () => {
                this.confirmIncomingCall();
            });

            this.$root.$on('tutorForceConnect', () => {
                if (!this.isTutorBroadcaster) {
                    return;
                }
                console.log('tutorForceConnect');
                this.onLessonCallAnswered({ channelid: this.channelid });
            });



            this.socket.on("CALL_USER_PINGBACK", (userData) => {
                const peerType = this.normalizeUserType(userData);

                if (this.isTutorBroadcaster && peerType === 'MEMBER') {
                    // Pingback only confirms the invite was received / user is online.
                    // Do NOT treat this as "answered" — wait for ACCEPT_CALL / MEMBER_ACCEPTED_CALL / JOIN_SESSION.
                    console.log("CALL_USER_PINGBACK from member (invite delivered)", userData);
                    this.studentPresentInRoom = true;
                    this.studentOnline = true;
                } else if (!this.isTutorBroadcaster && peerType === 'TUTOR') {
                    // Pingback from tutor is not an "accept" signal; member should join only when they accept the call.
                    console.log("CALL_USER_PINGBACK from tutor (invite delivered)", userData);
                }
            });

            this.$root.$on('openCustomerSupport', (alarmAudio) => { 
                this.$refs['TutorSessionInvite'].hideCallUserModal();                                          
                this.$refs['TutorSessionInvite'].hideCallUserModal();                                
                this.openFloatingChatBox();
            });     

            this.socket.on("ACCEPT_CALL", (userData) => {
                if (!this.isTutorBroadcaster) {
                    return;
                }

                this.destroyReconnect();
                this.reconnected = true;

                console.log("ACCEPT_CALL, (call accepted by member) ", userData);

                this.socket.emit('MEMBER_ACCEPTED_CALL', userData);
                this.onLessonCallAnswered(userData);
            });

            /** [start] MEMBER LESSON MINI TIMER **/
            this.socket.on("START_MEMBER_TIMER", (data) =>  {
                console.log("start member timer");
                if (this.$props.is_broadcaster == false) {                 
                    this.$refs['MemberLessonTimer'].setTimeRemaining(data.timeRemaining);
                    this.$refs['MemberLessonTimer'].startCountdown(); 
                }
            });

            this.socket.on("STOP_MEMBER_TIMER", (data) =>  {
                //MEMBER LESSON MINI TIMER
                if (this.$props.is_broadcaster == false) {
                    this.$refs['MemberLessonTimer'].stopCountdown(); 
                }
            });

            this.socket.on('SYNC_MEMBER_TIMER', (data) => {
                if (this.$props.is_broadcaster == true) {
                    return;
                }
                if (data && String(data.channelid) !== String(this.channelid)) {
                    return;
                }
                const timer = this.$refs['MemberLessonTimer'];
                if (timer && typeof timer.applyRemoteTimerState === 'function') {
                    timer.applyRemoteTimerState(data);
                }
            });
            
            
            this.socket.on('JOIN_SESSION', (userData) => {
                console.log("JOIN_SESSION", userData);

                const peerType = this.normalizeUserType(userData);
                if (this.isTutorBroadcaster && peerType === 'MEMBER') {
                    this.handlePeerJoinedSession(userData);
                    this.socket.emit('JOIN_SESSION_PINGBACK', this.user);
                } else if (!this.isTutorBroadcaster && peerType === 'TUTOR') {
                    this.handlePeerJoinedSession(userData);
                    this.socket.emit('JOIN_SESSION_PINGBACK', this.user);
                }
            });


            this.socket.on('JOIN_SESSION_PINGBACK', (userData) => {
                console.log("JOIN_SESSION_PINGBACK", userData);
                const peerType = this.normalizeUserType(userData);
                if (this.isTutorBroadcaster && peerType === 'MEMBER') {
                    this.handlePeerJoinedSession(userData);
                } else if (!this.isTutorBroadcaster && peerType === 'TUTOR') {
                    this.handlePeerJoinedSession(userData);
                }
            });

            this.socket.on('LEAVE_SESSION', (userData) => {
                let currrentTutor = this.getRecipient();

                if (userData.userid == currrentTutor.userid) {

                    if (this.$props.is_broadcaster == false) 
                    {

                        if (this.isLessonCompleted == false && this.isLessonStartTimeInvalid == false)    {

                            //console.log("TUTOR LEFT THE SESSION"); 

                            this.$refs['TutorSessionInvite'].removeParticipants(userData); 
                            this.$refs['TutorSessionInvite'].stopLessonTimer()
                            this.$refs['TutorSessionInvite'].showWaitingListModal();

                            //this.$refs['TutorSessionInvite'].resetLessonTimer()
                            //this.$refs['TutorSessionInvite'].startLessonStartTimer();

                            this.$refs['TutorSessionInvite'].resetWaitingTimer();
                            this.$refs['TutorSessionInvite'].startWaitingTimer()   

                        } else {
                            console.log(" BROADCASTER LEFT A SESSION !!! LESSON COMPLETED !!!");    
                        } 

                    } else {           

                         

                        //if (this.isLessonCompleted == false  && this.isLessonStartTimeInvalid == false &&  this.isUserAbsent  == false && this.isLessonExpired == false) 
                        //{

                        if (this.isLessonCompleted == false) {

                            /*
                            this.$refs['TutorSessionInvite'].removeParticipants(userData); 
                            this.$refs['TutorSessionInvite'].stopLessonTimer()
                            this.$refs['TutorSessionInvite'].showWaitingListModal();

                            //waiting timer for tutor to make an "emit" a "redialUser"
                            this.$refs['TutorSessionInvite'].resetWaitingTimer();
                            this.$refs['TutorSessionInvite'].startWaitingTimer()   
                            */

                            this.$refs['TutorSessionInvite'].removeParticipants(userData);  
                            this.$refs['TutorSessionInvite'].startWaitingTimer();
                            
                            this.$refs['TutorSessionInvite'].showWaitingListModal();
                        }

                        console.log("member left")
                    }
                        


                }
            });


            this.registerLessonSocketUser();
            /* LESSON BOARD / CANVAS — disabled
            if (!this.isTutorBroadcaster && this.socket.connected) {
                setTimeout(() => this.requestCanvasState(), 500);
                this.startCanvasStatePolling();
            }
            */

            this.socket.on("GOTO_SLIDE", (data) =>  {
                return; // LESSON BOARD / CANVAS — disabled
                if (!this.canvasEnabled) {
                    return;
                }

                console.log("GOTO_SLIDE RECIEVED", data);               

                if (this.$refs['audioPlayer']) {    
                    this.$refs['audioPlayer'].resetAudioIndex() 
                }
                this.viewerCurrentSlide = data.num
                this.currentSlide = data.num;
                this.$refs['LessonSlider'].goToSlide(data.num);            
            }); 


            this.socket.on("CREATE_NEW_SLIDE", (data) => {
                
                console.log("socket: CREATE_NEW_SLIDE", data);

                if (this.$props.is_broadcaster == false) {

                    console.log("Member: CREATE_NEW_SLIDE", data.currentslide);

                    this.slides = data.slidesCount;

                    this.$refs['LessonSlider'].createNewSlide();
                    this.$refs['LessonSlider'].goToSlide(data.currentslide);

                    if (data.backgroundURL) {
                        this.$refs['LessonSlider'].setSlideBackgroundImage(data.currentslide, data.backgroundURL);
                    }                
                    
                }           
            }); 

            /*[start] TUTOR SELECT A NEW SLIDE */
            this.socket.on('TUTOR_SELECTED_NEW_SLIDES', (response) => {
                try {
                    if (this.$props.is_broadcaster == false) {
                        this.$refs['LessonSlider'].openNewSlideMaterials(response.folderID);                       
                    }
                } catch (error) {
                    console.log("Error, tutor can't select new slide ", error);
                }
            });   
            
            this.$root.$on('triggerCallUser', (params) => {               
                this.callMember();
            });



            //this will show consecutive lesson confirmation and let tutor confirm
            this.$root.$on('tiggerStartSession', (params) => {
                this.showConsecutiveLessons();            
            });

            this.$root.$on('tiggerConfirmEndSession', (params) => {             
                this.confirmEndSession();            
            });
            

            this.$root.$on('triggerEndSession', (params) => {             
                this.triggerEndSession();            
            });
            

            //[start] Lesson (this will force everything to start)
            this.$root.$on('tiggerStartLesson', (params) => {
                this.startLesson(params);                
            });
            

            this.$root.$on('triggerFloatinChatBox', (params) => {
                this.openFloatingChatBox();
            });


            this.$root.$on('triggerLimitOverrideAndCallUser', (params) => {
                //@done: add lesson history to make the member continue the sesson, then call student
                this.limitOverrideAndCallStudent();
            })


            this.$root.$on('triggerMarkStudentAbsent', (params) => {
                this.markStudentAbsent();
            });



            //[start] Mini Task Timer
            this.$root.$on('triggerShowMiniTaskTimer', (params) => {
                this.triggerShowMiniTaskTimer();                
            });

            this.$root.$on('startMemberTimer', (timeRemaining) => {  

                //console.log("startMemberTimer") ;

                if (this.$props.is_broadcaster == true) {
                    this.socket.emit('START_MEMBER_TIMER', {
                        'channelid': this.channelid,
                        'timeRemaining': timeRemaining
                    });
                    this.$nextTick(() => this.broadcastMemberTimerStateIfRunning());
                } else {
                    //console.log("startMemberTimer")
                }
            });

            this.$root.$on('stopMemberTimer', (timeRemaining) => {        
                if (this.$props.is_broadcaster == true) {
                    this.socket.emit('STOP_MEMBER_TIMER', {
                        'channelid': this.channelid,
                        'timeRemaining': timeRemaining
                    });
                } else {
                    //console.log("startMemberTimer")
                }
            });

            this.$root.$on('playAlarmAudio', (alarmAudio) => {
                //console.log("play alarm audio", alarmAudio)
                this.playAlarmAudio(alarmAudio);
            });
            //[end] Mini Task Timer


            /****************AUDIO ACTIONS CONTROLLER (Broadcaster) **************** */
            this.$root.$on('playAudio', (index) => {
                if (this.$props.is_broadcaster == true) {
                    this.socket.emit('PLAY_AUDIO', {
                        'channelid': this.channelid,
                        'index':index
                    });
                } 
            });

            this.$root.$on('goToAudio', (index) => {
                if (this.$props.is_broadcaster == true) {
                    this.socket.emit('GOTO_AUDIO', {
                        'channelid': this.channelid,
                        'index':index
                    });
                } 
            });

            this.$root.$on('pauseAudio', (index) => {
                if (this.$props.is_broadcaster == true) {
                    this.socket.emit('PAUSE_AUDIO', {
                        'channelid': this.channelid,
                        'index':index
                    });
                } 
            });
                            
            this.$root.$on('nextAudio', (index) => {
                if (this.$props.is_broadcaster) {
                    this.socket.emit('NEXT_AUDIO', {
                        'channelid': this.channelid,
                        'index':index
                    }); 
                }
            });

            this.$root.$on('prevAudio', (index) => {
                if (this.$props.is_broadcaster) {
                    this.socket.emit('PREV_AUDIO', {
                        'channelid': this.channelid,
                        'index':index
                    }); 
                }
            });

            this.$root.$on('seekAudio', (data) => {
                if (this.$props.is_broadcaster) {
                    this.socket.emit('SEEK_AUDIO', {
                        'channelid': this.channelid,
                        'trackTime': data.trackTime,
                        'index': data.index
                    }); 
                }
            });


            /* AUDIO SOCKET CONTROLLER */
            this.socket.on('PLAY_AUDIO', (response) => {
                if (this.$props.is_broadcaster == false) {
                    this.$refs['LessonSlider'].$refs['audioPlayer'].gotoAndPlayClientAudio(response.index);  
                }
            });

            this.socket.on('GOTO_AUDIO', (response) => {
                if (this.$props.is_broadcaster == false) {                
                    this.$refs['LessonSlider'].$refs['audioPlayer'].gotoAndPlayClientAudio(response.index);  
                }
            });

            this.socket.on('PAUSE_AUDIO', (response) => {
                if (this.$props.is_broadcaster == false) {
                    this.$refs['LessonSlider'].$refs['audioPlayer'].stopAudio();       
                }
            });

            this.socket.on('NEXT_AUDIO', (response) => {
                if (this.$props.is_broadcaster == false) {
                    this.$refs['LessonSlider'].$refs['audioPlayer'].goToAudio(response.index);       
                }
            });

            this.socket.on('PREV_AUDIO', (response) => {           
                if (this.$props.is_broadcaster == false) {
                    this.$refs['LessonSlider'].$refs['audioPlayer'].goToAudio(response.index);
                }
            });

            this.socket.on('SEEK_AUDIO', (response) => {           
                if (this.$props.is_broadcaster == false) {
                    this.$refs['LessonSlider'].$refs['audioPlayer'].updateAudioTrackTime(response.trackTime);
                }
            });                        


            this.$root.$on('updateConsecutiveLessons', (response) => {
                this.$refs['memberFeedback'].updateConsecutiveSchedules(response.consecutiveSchedules);
            });


            this.$root.$on('updateSegments', (response) => {
                const lessonSliderComponent = this.$refs['LessonSlider'];
                let canvasSegments  = lessonSliderComponent.segments              
                this.$refs['memberFeedback'].updateLessonDetails(canvasSegments);  
            });


            
            this.$root.$on('redialUser', (response) => {
                if (this.lessonCallAnswered || this.lessonParticipantsConnected || this.isLessonMarkedActive()) {
                    return;
                }

                if (this.isUserAbsent == false && this.isTutorBroadcaster) {
                    // Only redial when the student is NOT present in this lesson room.
                    if (this.studentPresentInRoom) {
                        return;
                    }
                    this.socket.emit('CALL_USER', this.buildCallUserPayload()); 
                } else {
                    //console.log("I will not re-dial, since the user is a no show, we will wait for a manual call to action from the teacher moving forward")
                }

            }); 

        },
        beforeDestroy() {
            // this.stopCanvasStatePolling(); // LESSON BOARD / CANVAS — disabled
        },
       methods: {
            // --- LESSON BOARD / CANVAS (disabled — search "LESSON BOARD / CANVAS" to restore) ---
            bindLessonCanvasSocketEvents() {
                return;
                /* ORIGINAL — restore when re-enabling lesson board / canvas:
                if (this._lessonCanvasSocketBound || !this.socket) return;
                this._lessonCanvasSocketBound = true;
                const applyRemoteCanvasUpdate = (response) => { ... };
                this.socket.on('UPDATE_DRAWING', applyRemoteCanvasUpdate);
                this.socket.on('SEND_DRAWING', applyRemoteCanvasUpdate);
                this.socket.on('CANVAS_ENABLED', (payload) => this.handleRemoteCanvasEnabled(payload, 'CANVAS_ENABLED'));
                this.socket.on('UPDATE_CANVAS_STATE', (payload) => this.handleRemoteCanvasEnabled(payload, 'UPDATE_CANVAS_STATE'));
                this.socket.on('REQUEST_CANVAS_STATE', () => {
                    if (this.isTutorBroadcaster && this.canvasEnabled) this.broadcastCanvasEnabled();
                });
                */
            },
            registerLessonSocketUser() {
                if (!this.socket || !this.user) {
                    return;
                }
                this.user.channelid = this.lessonChannelId();
                this.socket.emit('REGISTER', this.user);
                this.socket.emit('register-user', Object.assign({}, this.user, {
                    userId: this.user.userid,
                    token: (typeof window !== 'undefined' && window.LESSON_ROOM_TOKEN) || '',
                }));
            },
            normalizeLessonChannel(value) {
                return String(value == null ? '' : value).trim();
            },
            lessonChannelId() {
                if (typeof window !== 'undefined' && window.LESSON_ROOM_ID) {
                    return this.normalizeLessonChannel(window.LESSON_ROOM_ID);
                }
                return this.normalizeLessonChannel(
                    this.$props.channelid
                    || (this.$props.reservation && this.$props.reservation.schedule_id)
                    || ''
                );
            },
            canvasPayloadMatchesLesson() { return false; },
            handleRemoteCanvasEnabled() { return; },
            startCanvasStatePolling() { return; },
            stopCanvasStatePolling() { return; },
            applyLessonLayout() { return; },
            requestCanvasState() { return; },
            broadcastCanvasEnabled() { return; },
            setCanvasEnabled() { return; },
            toggleLessonCanvas() { return; },
            /*
            --- LESSON BOARD / CANVAS (original implementations — uncomment block to restore) ---
            canvasPayloadMatchesLesson(payload) { ... }
            handleRemoteCanvasEnabled(payload, eventName) { ... }
            startCanvasStatePolling() { ... }
            stopCanvasStatePolling() { ... }
            applyLessonLayout() { ... }
            requestCanvasState() { ... }
            broadcastCanvasEnabled() { ... }
            setCanvasEnabled(enabled, broadcast) { ... }
            toggleLessonCanvas() { ... }
            See git history or agent transcript for full method bodies.
            */

             destroyReconnect() {
                // clean up the timeout
                if (this.disconnectTimeout) {
                    clearTimeout(this.disconnectTimeout);
                    this.disconnectTimeout = null;
                }
            },            

            async checkLessonSessionStatus() {
            
                if (this.lessonStatus == "CLIENT_NOT_AVAILABLE") {

                    this.title   = "NOTIFICATION";
                    this.message = "CLIENT WAS NOT AVAILABLE<br> ";
                    this.message += "Our client informed us that they are not available for this lesson, please proceed to your next lesson. thank you!";

                    this.promptUser();
                    this.$refs['NavigationMenu'].disableNavigationMenu();

                } else if (this.lessonStatus == "TUTOR_CANCELLED") {

                    this.title   = "NOTIFICATION";
                    this.message = "TUTOR WAS NOT AVAILABLE<br> ";
                    this.message += "Tutor not available for this lesson, please proceed to your next lesson. thank you!";

                    this.promptUser();

                    this.$refs['NavigationMenu'].disableNavigationMenu();            

                } else if (this.isLessonCompleted == true) {

                    this.promptSessionComplete();

                } else {

                    if (this.$props.is_lesson_started == true) {
                    
                        this.startLesson(this.consecutiveSchedules.duration);

                    } else {                
                    

                        console.log("checkSessionValid - check session valid");

                        //check if session is valid and call member or accept 
                        this.checkSessionValid(this.reservation);

                    }                
                }            
            },
            async checkSessionValid(reservationData) {                

                let params = {
                    'startTime' : this.consecutiveSchedules.duration.startTime,
                    'endTime'   : this.consecutiveSchedules.duration.endTime,
                    'length'    : this.consecutiveSchedules.duration.length
                };

                axios.post("/api/checkSessionValidity?api_token=" + this.api_token,
                {
                    'method'            : "POST",
                    'reservation'       : reservationData,
                    'startTime'         : params.startTime,
                    'endTime'           : params.endTime,
                    'duration'          : params.length,
                }).then(response => {

                    /************************************************************/
                    /*   [NEW!!!] LESSON VERIFIER 
                    /*
                    /* @description(1): calls the user is a tutor and if lesson is not started yest and valid lesson...
                    /* @description(2): accepts the tutor call if the user is a student
                    /************************************************************/

                    this.isLessonExpired        = response.data.isLessonExpired
                    this.isLessonStarted        = response.data.isLessonStarted;
                    this.isUserAbsent           = response.data.isUserAbsent;
                    this.callWaitingLimit       = response.data.callWaitingLimit;
                    this.totalElapsedMinutes    = response.data.totalElapsedMinutes;
                    this.gracePeriodInMinutes   = response.data.gracePerionInMinutes;
                    this.millisecondsLeft       = response.data.remaningDurationInMilliseconds;
                    this.message                = response.data.message;
                    this.title                  = response.data.title;
                    this.isLessonStartTimeInvalid = response.data.isStartTimeInvalid;


                    console.log("checkSessionValidity", response.data);

                    if (response.data.success == true && response.data.isLessonStarted == false 
                        && response.data.isLessonExceedGracePeriod == false 
                        && this.isLessonExpired  == false 
                        && this.isLessonExpired  == false 
                        && response.data.isStartTimeInvalid == false 
                        && this.isUserAbsent  == false ) {

                        //[calling is delagated to start lesson button 
                         if (this.isTutorBroadcaster && !this.lessonCallAnswered && !this.lessonParticipantsConnected) {
                            this.callMember();
                         }  else if (!this.isTutorBroadcaster) { 
                            //console.log("check session accept tutor call")
                            this.acceptTutorCall(); 
                        }
                        


                    } else if (response.data.success == false) {

                        if (response.data.isLessonStarted == false && response.data.isLessonExpired == true) {
                            this.isSessionExpired = true;
                            
                            //@todo: check if forced by tutor
                            //this.promptLessonAbsent();   
                            console.log("promptLessonAbsent 1")

                        } else if (this.isLessonStarted  == false && response.data.isUserAbsent == true) {                        

                            this.isUserAbsent = true;
                            //this.promptLessonAbsent();    
                            console.log("promptLessonAbsent 2" )

                        } else {                       

                             console.log("checkSessionValid promptUser" )

                            this.promptUser();  
                        }
                    } 

                });

            },
            async postLessonStartHistory(reservationData, params) { 

                //Pre-load the slides for saving
                this.currentSlide = await this.$refs['LessonSlider'].getCurrentSlide()
                this.slidesData = await this.$refs['LessonSlider'].getAllSlideData();

                //console.log(this.currentSlide, this.slidesData);

                axios.post("/api/postLessonStartHistory?api_token=" + this.api_token,
                {
                    'method'            : "POST",
                    'reservation'       : reservationData,
                    'startTime'         : params.startTime,
                    'endTime'           : params.endTime,
                    'duration'          : params.length,
                }).then(response => {

                    this.isLessonExpired        = response.data.isLessonExpired
                    this.isSessionExpired      = response.data.isLessonExpired;   

                    this.isLessonStarted        = response.data.isLessonStarted;
                    this.isUserAbsent           = response.data.isUserAbsent;
                    this.callWaitingLimit       = response.data.callWaitingLimit;
                    this.totalElapsedMinutes    = response.data.totalElapsedMinutes;
                    this.gracePeriodInMinutes   = response.data.gracePerionInMinutes;
                    this.millisecondsLeft       = response.data.remaningDurationInMilliseconds;
                    this.message                = response.data.message;
                    this.title                  = response.data.title;



                    if (response.data.success == true && response.data.isLessonExceedGracePeriod == false && response.data.isLessonExpired  == false 
                        && response.data.isUserAbsent  == false && params.isLessonStarted == false) {

                        this.startSession();

                    } else if (response.data.isLessonStarted == true && response.data.isLessonExpired == true) {                      

                        this.startSession(); 

                        if (this.is_broadcaster == true)  {
                            this.promptSessionExpiredOptions();
                        }                        
                        
                    } else if (response.data.isLessonStarted == false && response.data.isLessonExpired == true) { 
                  

                        console.log("promptSessionExpired");


                        this.isSessionExpired = true;      
                        this.promptSessionExpired();

                    } else if (response.data.isUserAbsent == true) {

                        this.isUserAbsent = true;

                        console.log("promptLessonAbsent");

                        this.promptLessonAbsent();                    

                    } else if (response.data.success == true && response.data.isLessonStarted == true) {

                        this.startSession();

                    } else if (response.data.success == true && params.isLessonStarted == true) {

                        this.startSession();

                    } else if (response.data.success == false) { 

                        console.log("promptUser");

                        //Prompt user if success if false                   
                        this.promptUser();    
                    }
                         
                });
            },
   
            async startSession() {

                axios.post("/api/startLesson?api_token=" + this.api_token,
                {
                    'method'          : "POST",
                    'folder_id'       : this.$props.folder_id,
                    'totalSlides'     : this.slidesData.length,
                    'currentSlide'    : this.currentSlide,
                    'reservation'     : this.reservation, //reservationData,                
                    'slidesData'      : this.slidesData,        
                    'isTimerStarted'  : this.isTimerStarted

                }).then(response => {


                   //console.log("success", response.data.success);
                   //console.log("is lesson expired?", this.isLessonExpired);
                   //console.log("is session expired?", this.isSessionExpired);            
             

                    if (response.data.success == true) {
                        
                        this.$refs['NavigationMenu'].startTimer();
                        //console.log("emit start session")
                        this.socket.emit('START_SESSION', this.getSessionData());   

                        if (this.isMainTimerStarted == false) {
                            //console.log("this.startCountdown();")
                            this.startCountdown(); 
                        }

                   

                        this.$refs['MemberConsecutiveLessons'].hideConsecutiveLessonModal(); 

                        //if session has not started then save all slides to slide history
                        if (this.isLessonStarted == false) {

                            //console.log("|| =================== SESSION_START =================== ||");

                            this.socket.emit('JOIN_SESSION', this.user); 

                            this.$refs['LessonSlider'].saveAllSlides();

                        } else if (this.isLessonStarted == true && this.isSessionExpired == false) {

                            //[NOTE] ADDED TO COMPLEMENT CALLING THE TUTOR IF REFRESHED

                            if (this.$props.is_broadcaster == true) {

                                //console.log("we are calling member, since it has not expired")
                                this.callMember(); 

                            } else {

                                //console.log("check session accept tutor call")
                                this.acceptTutorCall(); 

                            }

                        } else {

                            if (this.$props.is_broadcaster == true) {

                                if (this.isLessonStarted == true && this.isSessionExpired == false) {

                                   this.callMember();

                                } else if (this.isLessonStarted == true && this.isSessionExpired == true) {                              

                                  // this.callMember();  (delegate to popup)

                                } else if (this.isLessonStarted == false && this.isSessionExpired == false) {
                                
                                    //console.log("|| XXXXXXXXXXXXXXXXXX  SESSION_NOT_STARTED  XXXXXXXXXXXXXXXXXX  ||")

                                } else {

                                    //console.log("|| ??????????????????? SESSION IS UNKNOWN HERE ??????????????????? ||")
                                }

                            } else {


                                this.$refs['TutorSessionInvite'].showWaitingListModal();

                            
                                //member joined...
                                console.log("EMIT JOIN_SESSION TO TUTOR");
                                this.socket.emit('JOIN_SESSION', this.user); 
                            }

                        }

                    } else {
                    

                    }
                });

            },
            async limitOverrideAndCallStudent() {

                this.currentSlide = await this.$refs['LessonSlider'].getCurrentSlide()
                this.slidesData = await this.$refs['LessonSlider'].getAllSlideData();

                axios.post("/api/LessonLimitOverride?api_token=" + this.api_token,
                {
                    'method'          : "POST",
                    'folder_id'       : this.$props.folder_id,
                    'totalSlides'     : this.slidesData.length,
                    'currentSlide'    : this.currentSlide,
                    'reservation'     : this.reservation, //reservationData,                
                    'slidesData'      : this.slidesData,        
                    'isTimerStarted'  : this.isTimerStarted

                }).then(response => {
                    this.callMember();
                    this.$refs['NavigationMenu'].enableNavigationMenu();
                });
            },
            customSelectorBounds(fabric) {
                fabric.Object.prototype.transparentCorners = false;
                fabric.Object.prototype.cornerColor = 'blue';
                fabric.Object.prototype.cornerStyle = 'circle';
            },
            isUserPresentInRoom(users, userId, channelId) {
                if (!userId || !channelId || !users || !users.length) {
                    return false;
                }
                return users.some((u) => {
                    const uid = u && (u.userid != null ? String(u.userid) : '');
                    const ch = u && (u.channelid != null ? String(u.channelid) : '');
                    return uid === String(userId) && ch === String(channelId);
                });
            },
            updateUserList: function(users) {
                this.users = users;      
                const channelId = this.lessonChannelId();
                const peerId = this.$props.recipient_info && this.$props.recipient_info.userid;

                if (this.isTutorBroadcaster) {
                    const wasStudentPresent = this.studentPresentInRoom;
                    this.studentPresentInRoom = this.isUserPresentInRoom(users, peerId, channelId);
                    this.studentOnline = this.studentPresentInRoom; // keep legacy prop in sync
                    if (!wasStudentPresent && this.studentPresentInRoom && this.isLessonSessionActive()) {
                        this.scheduleLessonTimerSync();
                        this.broadcastMemberTimerStateIfRunning();
                    }
                    this.lastStudentPresentInRoom = this.studentPresentInRoom;

                    if (typeof window !== 'undefined' && typeof window.setLessonRemoteOverlay === 'function' && !this.isLessonMarkedActive()) {
                        if (!this.studentPresentInRoom) {
                            window.setLessonRemoteOverlay('Student got disconnected — redialing the student…', { source: 'app', lock: true });
                        } else if (!this.lessonCallAnswered && !this.lessonParticipantsConnected) {
                            // Student is present; do not redial. Let WebRTC handle reconnecting.
                            window.setLessonRemoteOverlay(null, { source: 'app', lock: false });
                        } else {
                            window.setLessonRemoteOverlay(null, { source: 'app', lock: false });
                        }
                    }
                } else {
                    const wasTutorPresent = this.tutorPresentInRoom;
                    this.tutorPresentInRoom = this.isUserPresentInRoom(users, peerId, channelId);
                    if (!wasTutorPresent && this.tutorPresentInRoom && this.isLessonSessionActive()) {
                        this.scheduleLessonTimerSync();
                    }
                    this.lastTutorPresentInRoom = this.tutorPresentInRoom;
                    if (typeof window !== 'undefined' && typeof window.setLessonRemoteOverlay === 'function') {
                        if (!this.tutorPresentInRoom) {
                            window.setLessonRemoteOverlay('Tutor got disconnected — waiting to reconnect…', { source: 'app', lock: true });
                        } else {
                            // Tutor is present; allow WebRTC layer to show "Reconnecting…" if needed.
                            window.setLessonRemoteOverlay(null, { source: 'app', lock: false });
                        }
                    }
                }
                this.$forceUpdate();                 
            },
            getSessionData() {                
                this.currentSlide = this.$refs['LessonSlider'].getCurrentSlide()
                this.slidesData = this.$refs['LessonSlider'].getAllSlideData();
                let sessionData = {
                    'totalSlide'    : this.slidesData.length,
                    'currentslide'  : this.currentSlide,                       
                    'channelid'     : this.channelid,
                    'sender'        : { userid: this.user_info.id, username: this.user_info.username},
                    'recipient'     : this.getRecipient()
                };  
                return sessionData;  
            },
            getRecipient() { 
                return this.$props.recipient_info;
            },
            buildCallUserPayload() {
                const scheduleId = String(this.channelid || (this.$props.reservation && this.$props.reservation.schedule_id) || '');
                const reservation = this.$props.reservation || {};
                const memberUserId = reservation.member_user_id || (this.$props.recipient_info && this.$props.recipient_info.userid);
                const recipient = Object.assign({}, this.$props.recipient_info, {
                    channelid: scheduleId,
                    userid: String(memberUserId || ''),
                });
                const payload = {
                    channelid: scheduleId,
                    roomId: scheduleId,
                    caller: Object.assign({}, this.user, { channelid: scheduleId }),
                    recipient: recipient,
                    reservationData: reservation,
                };
                console.log('CALL_USER emit → member user id', recipient.userid, 'schedule', scheduleId);
                return payload;
            },
            normalizeUserType(userData) {
                return ((userData && userData.type) || '').toUpperCase();
            },
            isLessonSessionActive() {
                return this.isLessonMarkedActive()
                    || this.lessonParticipantsConnected
                    || this.lessonCallAnswered
                    || this.peerSessionUiReady
                    || this.isMainTimerStarted;
            },
            isLessonMarkedActive() {
                if (typeof window === 'undefined' || !window.sessionStorage) {
                    return false;
                }
                const key = 'lesson_active_' + this.lessonChannelId();
                return !!window.sessionStorage.getItem(key);
            },
            handleTutorReconnectDuringLesson(userData) {
                this.markLessonChannelActive(true);
                this.stopIncomingCallAudio();
                this.hideAllInviteModals();
                this.destroyReconnect();
                this.reconnected = true;
                this.pendingIncomingCall = null;
                if (typeof window !== 'undefined' && typeof window.setLessonRemoteOverlay === 'function') {
                    window.setLessonRemoteOverlay(null, { source: 'app', lock: false });
                }

                if (userData && userData.caller) {
                    this.emitCallPingback(userData.caller);
                }

                if (!this.lessonParticipantsConnected) {
                    this.connectLessonParticipants();
                }

                this.scheduleLessonTimerSync();
            },
            scheduleLessonTimerSync() {
                if (this.lessonTimerSyncTimer) {
                    clearTimeout(this.lessonTimerSyncTimer);
                }
                this.lessonTimerSyncTimer = setTimeout(() => {
                    this.lessonTimerSyncTimer = null;
                    this.syncLessonTimerFromServer();
                }, 400);
            },
            async syncLessonTimerFromServer() {
                if (!this.isLessonSessionActive() && !this.isLessonStarted) {
                    return;
                }
                const duration = this.consecutiveSchedules && this.consecutiveSchedules.duration;
                if (!duration || !this.reservation) {
                    return;
                }
                try {
                    const response = await axios.post('/api/checkSessionValidity?api_token=' + this.api_token, {
                        method: 'POST',
                        reservation: this.reservation,
                        startTime: duration.startTime,
                        endTime: duration.endTime,
                        duration: duration.length,
                    });
                    const remaining = response.data && response.data.remaningDurationInMilliseconds;
                    if (remaining == null || remaining === undefined) {
                        return;
                    }
                    this.resyncMainCountdown(remaining);
                } catch (error) {
                    console.warn('[lesson] timer sync failed', error);
                }
            },
            resyncMainCountdown(millisecondsLeft) {
                if (this.countdownInterval) {
                    clearInterval(this.countdownInterval);
                    this.countdownInterval = null;
                }
                this.isMainTimerStarted = true;
                this.millisecondsLeft = millisecondsLeft;
                this.calculateTimeLeft();
                this.countdownInterval = setInterval(() => {
                    this.millisecondsLeft -= 1000;
                    this.calculateTimeLeft();
                }, 1000);
                if (this.$refs['NavigationMenu']) {
                    this.$refs['NavigationMenu'].startTimer();
                }
            },
            broadcastMemberTimerStateIfRunning() {
                if (!this.isTutorBroadcaster || !this.socket) {
                    return;
                }
                const timer = this.$refs['MemberLessonTimer'];
                if (!timer || !timer.isTimerStarted || typeof timer.getTimerSnapshot !== 'function') {
                    return;
                }
                const snapshot = timer.getTimerSnapshot();
                this.socket.emit('SYNC_MEMBER_TIMER', Object.assign({}, snapshot, {
                    channelid: this.channelid,
                }));
            },
            emitCallPingback(tutor) {
                const pingbackUser = Object.assign({}, this.user, {
                    channelid: String(this.channelid),
                    type: 'MEMBER',
                });
                this.socket.emit('CALL_USER_PINGBACK', pingbackUser);

                if (tutor && tutor.userid) {
                    this.socket.emit('CALL_USER_PINGBACK', Object.assign({}, pingbackUser, {
                        recipient: tutor,
                    }));
                }
            },
            hideAllInviteModals() {
                const invite = this.$refs['TutorSessionInvite'];
                if (!invite) {
                    return;
                }
                invite.hideCallUserModal();
                invite.hideIncomingCallModal();
                invite.hideWaitingListModal();
            },
            announceLessonPresence() {
                if (!this.socket || !this.user) {
                    return;
                }
                this.socket.emit('LESSON_PEER_READY', Object.assign({}, this.user, {
                    roomId: String(this.channelid),
                }));
            },
            tryJoinWhenPeerOnline(users) {
                const peerId = this.$props.recipient_info && this.$props.recipient_info.userid;
                if (!peerId || !users || !users.length) {
                    return;
                }
                const peerOnline = users.some((u) => String(u.userid) === String(peerId));
                if (!peerOnline) {
                    return;
                }
                // Tutor must emit CALL_USER first — do not treat "student online" as answered.
                if (this.isTutorBroadcaster) {
                    if (!this.lessonCallAnswered && !this.lessonParticipantsConnected && !this.isLessonMarkedActive()) {
                        console.log('student online on lesson channel — tutor will call');
                        this.callMember();
                    }
                    return;
                }
                if (this.isLessonSessionActive()) {
                    this.handleTutorReconnectDuringLesson({ caller: this.$props.recipient_info });
                    return;
                }

                if (!this.peerSessionUiReady) {
                    const peer = Object.assign({}, this.$props.recipient_info, {
                        type: 'TUTOR',
                    });
                    this.handlePeerJoinedSession(peer);
                }
            },
            handlePeerJoinedSession(peer) {
                this.peerSessionUiReady = true;
                this.hideAllInviteModals();

                if (this.$refs['TutorSessionInvite']) {
                    this.$refs['TutorSessionInvite'].markPeerJoined(peer);
                }

                if (!this.isTutorBroadcaster && this.isMainTimerStarted === false) {
                    this.startCountdown();
                }

                if (!this.lessonParticipantsConnected) {
                    this.connectLessonParticipants();
                }

                /* LESSON BOARD / CANVAS — disabled
                if (this.isTutorBroadcaster && this.canvasEnabled) {
                    this.broadcastCanvasEnabled();
                } else if (!this.isTutorBroadcaster) {
                    this.requestCanvasState();
                }
                */

                this.maybeAutoStartLesson();
            },
            markLessonChannelActive(active) {
                if (typeof window === 'undefined' || !window.sessionStorage) {
                    return;
                }
                const key = 'lesson_active_' + this.lessonChannelId();
                if (active) {
                    window.sessionStorage.setItem(key, '1');
                } else {
                    window.sessionStorage.removeItem(key);
                }
            },
            connectLessonParticipants() {
                if (this.lessonParticipantsConnected) {
                    return;
                }

                this.lessonParticipantsConnected = true;
                this.markLessonChannelActive(true);
                this.hideAllInviteModals();
                this.stopIncomingCallAudio();
                console.log('connectLessonParticipants', this.user.type);
                this.socket.emit('JOIN_SESSION', this.user);
            },
            maybeAutoStartLesson() {
                if (!this.shouldAutoConnectLesson || this.isLessonStarted) {
                    return;
                }

                if (this.consecutiveSchedules && this.consecutiveSchedules.duration) {
                    this.showConsecutiveLessons();
                }
            },
            onLessonCallAnswered(userData) {
                this.lessonCallAnswered = true;
                this.hideAllInviteModals();

                this.$nextTick(() => {
                    this.hideAllInviteModals();
                });

                if (this.tutorBypassConnectTimer) {
                    clearTimeout(this.tutorBypassConnectTimer);
                    this.tutorBypassConnectTimer = null;
                }

                if (userData && userData.recipient) {
                    this.socket.emit('JOIN_SESSION_PINGBACK', userData.recipient);
                } else if (userData && userData.tutorData) {
                    this.socket.emit('JOIN_SESSION_PINGBACK', userData.tutorData);
                }

                this.connectLessonParticipants();
                this.maybeAutoStartLesson();
                if (typeof window !== 'undefined' && typeof window.setLessonRemoteOverlay === 'function') {
                    window.setLessonRemoteOverlay(null, { source: 'app', lock: false });
                }
                if (this.isTutorBroadcaster && this.isLessonSessionActive()) {
                    this.scheduleLessonTimerSync();
                    this.broadcastMemberTimerStateIfRunning();
                }
            },
            startTutorBypassConnect() {
                if (this.tutorBypassConnectTimer) {
                    clearTimeout(this.tutorBypassConnectTimer);
                }

                this.tutorBypassConnectTimer = setTimeout(() => {
                    if (!this.lessonCallAnswered) {
                        console.log('tutor bypass connect timeout - continuing lesson');
                        this.onLessonCallAnswered({ channelid: this.channelid });
                    }
                }, 15000);
            },
            acceptTutorCall() {
                const tutor = this.$props.recipient_info;
                this.emitCallPingback(tutor);

                if (this.shouldAutoConnectLesson) {
                    this.socket.emit('LESSON_CALL_ANSWERED', {
                        channelid: String(this.channelid),
                        member: this.user,
                        tutor: tutor,
                        reservationData: this.$props.reservation,
                    });
                }
            },
            confirmIncomingCall() {
                if (!this.pendingIncomingCall) {
                    return;
                }

                const userData = this.pendingIncomingCall;
                const callData = {
                    tutorData: userData.caller,
                    channelid: String(this.channelid),
                    caller: this.user,
                    recipient: userData.caller,
                    reservationData: userData.reservationData,
                    callReservation: userData.reservationData,
                };

                console.log('emit ACCEPT_CALL to tutor', userData.caller.userid);
                this.socket.emit('ACCEPT_CALL', callData);
                this.socket.emit('LESSON_CALL_ANSWERED', {
                    channelid: String(this.channelid),
                    member: this.user,
                    tutor: userData.caller,
                    reservationData: userData.reservationData,
                });
                this.emitCallPingback(userData.caller);
                this.stopIncomingCallAudio();
                this.$refs['TutorSessionInvite'].hideIncomingCallModal();
                this.pendingIncomingCall = null;
                this.connectLessonParticipants();
                this.maybeAutoStartLesson();
            },
            playIncomingCallAudio() {
                if (this.isPlayingIncomingCall) {
                    return;
                }

                this.isPlayingIncomingCall = true;
                let remainingPlays = 50;
                const playLoop = () => {
                    if (remainingPlays <= 0) {
                        this.stopIncomingCallAudio();
                        return;
                    }

                    let audio = document.getElementById('lessonIncomingCallAudio');
                    if (!audio) {
                        return;
                    }

                    audio.src = window.location.origin + '/mp3/incoming-call.mp3';
                    audio.load();
                    audio.play().catch(() => {});
                    remainingPlays--;
                };

                playLoop();
                this.incomingCallAudioInterval = setInterval(playLoop, 3000);
            },
            stopIncomingCallAudio() {
                clearInterval(this.incomingCallAudioInterval);
                this.isPlayingIncomingCall = false;
                const audio = document.getElementById('lessonIncomingCallAudio');
                if (audio) {
                    audio.pause();
                    audio.currentTime = 0;
                }
            },
            callMember() {

                if (!this.isTutorBroadcaster
                    || this.lessonCallAnswered
                    || this.lessonParticipantsConnected
                    || this.isLessonMarkedActive()
                ) {
                    console.log('callMember skipped', {
                        isTutor: this.isTutorBroadcaster,
                        answered: this.lessonCallAnswered,
                        connected: this.lessonParticipantsConnected,
                    });
                    return;
                }

                if (this.isTutorBroadcaster) {

                    this.socket.emit('CALL_USER', this.buildCallUserPayload());

                    // Bypass mode is for time-gating only; do not auto-connect without student acceptance.

                } else {
                
                    //console.log("calling tutor (inactive)");
                }
        
            },                  
            promptLessonAbsent() {

                this.$refs['NavigationMenu'].disableNavigationMenu();                            

                if (this.$props.is_broadcaster == true) {
                
                    let params = {                                  
                                'title'     : this.title, 
                                'message'   : this.message,
                                'callWaitingLimit': this.callWaitingLimit,
                            }

                    this.$refs['TutorSessionInvite'].showModalAbsent(params);  

                } else {
                
                    let params = {                                  
                                'title'     : this.title, 
                                'message'   : this.message,
                                'callWaitingLimit': this.callWaitingLimit,
                            }

                    this.$refs['TutorSessionInvite'].showModalAbsent(params);                  
                }
             
            },
            promptSessionExpiredOptions() {   

                //lesson has been started, show continue
                //@todo: mark its first lesson if expired.

                let params = {  'title'     : this.title, 
                                'message'   : this.message
                            }
                this.$refs['TutorSessionInvite'].showSessionExpiredOptionsModal(params);   

            },
            promptSessionExpired() { 

                console.log("promptSessionExpired")

                //this lesson if for lesson that has not started, 
                //it will not show continue
                //@todo: mark its first lesson if expired.

                let params = {'title': this.title, 'message': this.message }
                this.$refs['NavigationMenu'].disableNavigationMenu();
                this.$refs['TutorSessionInvite'].showModalExpired(params);                           
            },
            promptUser() {               
                let params = {'title': this.title, 'message': this.message }
                this.$refs['TutorSessionInvite'].showUserPromptModal(params); 
            },
            promptSessionComplete() {
                console.log("promptSessionComplete");

                this.$refs['NavigationMenu'].disableNavigationMenu();
                //this.$refs['TutorSessionInvite'].showModalCompleted();

                if (this.$props.is_broadcaster == true) {
                    this.showMemberFeedbackModal();
                } else {
                    //this.showSatisfactionSurveyModal();
                    this.$refs['satisfactionSurvey'].showThankYou(this.reservation);

                }               
            },
            hideMemberFeebackModal() {
                this.$refs['memberFeedback'].hideMemberFeedbackModal();
            },
            async showMemberFeedbackModal() { 
            
                const lessonSliderComponent = this.$refs['LessonSlider'];

                if (!lessonSliderComponent) {
                    // Handle the case when the component is not found
                    return;
                }

                // Define a function that returns a Promise when the files have a value
                const waitForFiles = () => {
                    return new Promise((resolve) => {
                        const checkFiles = () => {
                            if (lessonSliderComponent.files) {
                                resolve(lessonSliderComponent.files);
                            } else {
                                // Check again after a short delay
                                setTimeout(checkFiles, 100);
                            }
                        };
                        checkFiles();
                    });
                };

                // Wait for the files to have a value
                const files = await waitForFiles();                
                
                if (lessonSliderComponent.segments && lessonSliderComponent.segments.length) {
                    this.$refs['memberFeedback'].updateLessonDetails(lessonSliderComponent.segments);
                }
                this.$refs['memberFeedback'].showMemberFeedbackModal(this.reservation, files);
                
            },
            showSatisfactionSurveyModal() {
                this.$refs['satisfactionSurvey'].showSatisfactionSurveyModal(this.reservation);
            },
            showConsecutiveLessons() {
                if (this.consecutiveSchedules.lessons.length > 1) {
                    this.$refs['MemberConsecutiveLessons'].setConsecutiveLessons(this.consecutiveSchedules);
                } else {

                    //(this will auto start lesson since it will not show consecutive lessons)
                    let params = {
                        'startTime' : this.consecutiveSchedules.duration.startTime,
                        'endTime'   : this.consecutiveSchedules.duration.endTime,
                        'length'    : this.consecutiveSchedules.duration.length,
                        'isLessonStarted': true, //force lesson started (since)
                    };

                    this.startLesson(params); 
                }               
            },
            startLesson(params) {                 
                this.postLessonStartHistory(this.reservation, params);
            },            
            openFloatingChatBox() {
                const floatingChat = this.$refs['memberFloatingChat'];
                if (!floatingChat) {
                    return;
                }
                floatingChat.openFloatingChatIcon();
                floatingChat.openChatBox();
            },
            //Main Countdown timer
            startCountdown(millisecondsLeft) {
                if (this.countdownInterval) {
                    clearInterval(this.countdownInterval);
                    this.countdownInterval = null;
                }
                this.isMainTimerStarted = true;

                //if method passed a parameter take this parameter else this.milliseconds will be added as value
                if (!(millisecondsLeft == null || millisecondsLeft == undefined || millisecondsLeft == 'undefined')) {
                    this.millisecondsLeft = millisecondsLeft;
                } 
                
                this.countdownInterval = setInterval(() => {
                    this.millisecondsLeft -= 1000;
                    this.calculateTimeLeft();

                    if (this.millisecondsLeft <= 0) {
                        //clearInterval(this.countdownInterval);
                    }
                }, 1000);
            },
            stopCountdown() {
                clearInterval(this.countdownInterval); 
                this.$refs['NavigationMenu'].stopTimer();                
            },
            calculateTimeLeft() 
            {               
                const seconds = Math.floor(Math.abs(this.millisecondsLeft) / 1000);
                const minutes = Math.floor(seconds / 60);
                const hours = Math.floor(minutes / 60);

                const formattedSeconds = String(seconds % 60).padStart(2, "0");
                const formattedMinutes = String(minutes % 60).padStart(2, "0");
                const formattedHours = String(hours).padStart(2, "0");

                const sign = this.millisecondsLeft < 0 ? "-" : "";

                this.formattedTime = `${sign}${formattedHours}:${formattedMinutes}:${formattedSeconds}`;

                //update the navigation menu timer
                this.$refs['NavigationMenu'].updateTimer(this.formattedTime);

                //check expired every timer updates
                if (this.millisecondsLeft <= 0) {
                    if (hours >= 1 || minutes >= this.gracePeriodInMinutes) 
                    {
                        /* GRACE PERIOD 15 MINUTES (IN MEMBER NO NEED TO STOP IT AND PROMPT) */
                        /*
                        if (this.isLessonStarted == true) {    
                             console.log("calculateTimeLeft -> promptSessionExpiredOptions() ")
                            //Lesson has been started, prompt user to end it since it has expired
                            //this.promptSessionExpiredOptions();
                        } else {
                            console.log("calculateTimeLeft -> promptSessionExpired() ")
                            //clearInterval(this.countdownInterval);
                            //this.promptSessionExpired();                            
                        }                
                        */        
                    }

                }                                
            },           
            //[start] Mini Task Timer
            triggerShowMiniTaskTimer() {
                this.$refs['MemberLessonTimer'].showTimerControlModal()
            },
            startMemberTimer() {
                console.log("START_MEMBER_TIMER - EMIT")

                this.socket.emit('START_MEMBER_TIMER', this.getSessionData()); 
                this.isMainTimerStarted = true;
            },
            //[end] Mini Task Timer        
            playAlarmAudio(audio) {                
                let alarmAudio = document.getElementById('alarmAudio');
                if (alarmAudio) {      
                    alarmAudio.src = window.location.origin +"/"+ audio.path;                              
                    alarmAudio.load();
                    alarmAudio.play();  
                }
            },
            markStudentAbsent() 
            {
                axios.post("/api/postLessonAbsentHistory?api_token=" + this.api_token, 
                {
                    'reservation'     : this.reservation,                            
                }).then(response => {                  

                    if (response.data.success == true) {

                        this.$nextTick(() => { 
                            this.$refs['TutorSessionInvite'].backToMemberHome();
                        });

                    } else {
                    
                        this.title   = "NOTIFICATION";                        
                        this.message = response.data.message;
                        this.promptUser();    

                    }
                    
                });
            },
            //[start] End Lesson
            async confirmEndSession() {

                const h = this.$createElement;

                const messageVNode = h('div', { class: ['foobar'] }, [
                    h('p', { class: ['text-center'] }, [ h('strong', 'Please confirm that you want to end lesson')]),
                ]);                        

                this.$bvModal.msgBoxConfirm(messageVNode, {                
                    title: 'End Session Confirmation',
                    contentClass: 'esi-modal',
                    headerBgVariant: 'lightblue',
                    headerTextVariant: 'white',
                    buttonSize: 'md',

                    okVariant: 'danger',
                    okTitle: 'END SESSION',
                    cancelVariant: 'primary',
                    cancelTitle: 'CONTINUE SESSION',
                    footerClass: 'p-2',

                    'hideHeaderClose': false,
                    'noCloseOnBackdrop': true,
                    'noCloseOnEsc': true,
                    'centered': false,
                }).then(isConfirmed => {

                    if (isConfirmed == true)  {
                        this.endSession();                      
                    }
                }).catch(err => {                    
                    alert (err)                
                });             
            },
            async triggerEndSession() {            
                if (this.isSessionExpired == true) {
                    this.endSession();
                }
            },            
            terminateLessonWebRTC() {
                if (typeof window.destroyLessonWebRTC === 'function') {
                    window.destroyLessonWebRTC();
                } else {
                    const btn = document.getElementById('destroy-session-media');
                    if (btn) {
                        btn.click();
                    }
                }
            },
            async endSession() {
                this.terminateLessonWebRTC();
                this.isLessonCompleted = true;

                this.$refs['LessonSlider'].resetCanvas();
                this.$refs['LessonSlider'].saveAllSlides();
                this.postLessonEndSessionHistory(this.reservation);
            },
            async postLessonEndSessionHistory(reservationData) {
            
                if (this.$props.is_broadcaster == false) {                       
                    alert ("Member is not allowed to end a session");
                    return false
                }    

            
                this.currentSlide = await this.$refs['LessonSlider'].getCurrentSlide();
                this.slidesData = await this.$refs['LessonSlider'].getAllSlideData();

                //@note: save session history
                axios.post("/api/postLessonEndHistory?api_token=" + this.api_token,
                {
                    'method'          : "POST",
                    'folder_id'       : this.$props.folder_id,
                    'currentSlide'    : this.currentSlide,
                    'slidesData'      : this.slidesData,
                    'totalSlides'     : this.slidesData.length,
                    'consecutiveSchedules': this.consecutiveSchedules,
                    'reservation'     : reservationData,                                    
                    'isTimerStarted'  : this.isTimerStarted  

                }).then(response => {

                    this.isLessonCompleted = true;
                    this.stopCountdown(); 
                    if (this.is_broadcaster == true) {
                        this.$refs['NavigationMenu'].stopTimer();                    
                        this.$refs['NavigationMenu'].disableNavigationMenu();
                        this.socket.emit('END_SESSION', this.getSessionData()); 
                        //console.log("session end was broadcasted");


                        //this.showMemberFeedbackModal(this.reservation, this.files);
                        this.showMemberFeedbackModal();

                        $("#destroy-session-media").trigger("click"); 
                    }

                    return true;
            });
            },
            testConsecutive() {

                axios.post("/api/testConsecutiveLesson?api_token=" + this.api_token,
                {
                    'method'          : "POST",
                    'reservation'     : this.reservation,                
                    'consecutiveSchedules': this.consecutiveSchedules,
                }).then(response => {

                        console.log(response.consecutiveSchedules);

                });


              
              
            }


        }
    }
 
</script>